module.exports = __webpack_public_path__ + "static/media/29EUNOG6.10eb60e2.jpg";